import {firebaseInstance as firebase} from "@/main";
import Utils from "@/helpers/Utils";
import DateUtils from "@/helpers/DateUtils";
import {validateUploadOptions, handleUploadTask} from "@/store/firebase/firebaseHelpers.js";
export default {
	namespaced: true,
	actions: {
		uploadFile: ({commit}, options) => {
			return new Promise((resolve, reject) => {
				try {
					validateUploadOptions(options);
					const defaultMetaData = options.metaData || {contentType: options.file.type};
					const respExt = Utils.checkExt(options.file);
					const extFileName = respExt.ext;
					const timeStamp = DateUtils.timeStamp();
					const genFileName = `${options.file.name}-${timeStamp}.${extFileName}`;
					const pathStorageFileName = `${options.path}/${genFileName}`;
					const storageService = firebase.storage();
					const storageRef = storageService.ref();
					const uploadTask = storageRef.child(pathStorageFileName).put(options.file, defaultMetaData);
					handleUploadTask(uploadTask, options.public, pathStorageFileName, genFileName, resolve, reject); // Manejo separado
				} catch (error) {
					console.warn(error);
					reject(error);
				}
			});
		},
		setMetaData: ({commit}, fileRef) => {
			//current: Not allowed to set custom metadata for firebaseStorageDownloadTokens
			return new Promise((resolve, reject) => {
				if (fileRef === undefined || fileRef === null) {
					const error = "fileRef is missing";
					console.warn(error);
					reject(error);
				}
				const updateMetaData = {
					cacheControl: "private",
					customMetadata: {
						firebaseStorageDownloadTokens: null,
					},
				};
				fileRef
					.updateMetadata(updateMetaData)
					.then((metadata) => {
						// metadata.contentType should be null
						console.info("metadata updated:", metadata);
						resolve(metadata);
					})
					.catch((error) => {
						// Uh-oh, an error occurred!
						console.error("Uh-oh, an error occurred, while updated metadata!", error);
						reject(error);
					});
			});
		},
	},
};
